import { render, staticRenderFns } from "./ImageHeader.vue?vue&type=template&id=536f48e1"
import script from "./ImageHeader.vue?vue&type=script&lang=ts"
export * from "./ImageHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports